//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		name: "article-full",

        props: {
			article: Object,
            title: false,
            index: null,
        },
	}
